export default __webpack_public_path__ + "static/media/refresh.8c945054.svg";